// extracted by mini-css-extract-plugin
export default {"vote":"index_vote_zn-qh","voted":"index_voted_uFPeQ"};